import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceReportBulkUpdate from './InsuranceReportBulkUpdate';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	ids: string[];
	onUpdate: () => void;
}

const InsuranceReportBulkUpdateModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.insuranceReportBulkUpdate.title'
			size={Size.MD}
			{...props}>
			<InsuranceReportBulkUpdate ids={props.ids} onUpdate={props.onUpdate} />
		</BaseModal>
	);
};

export default InsuranceReportBulkUpdateModal;
